/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EvaluationRowSchema } from './evaluationRowSchema';

export interface EvaluationListResponse {
  rows: EvaluationRowSchema[];
  total: number;
  page: number;
  per_page: number;
}
